import i18n from '../../../i18n';
import { INSTALLATION_HELP_URL } from '../../../../native/notion/js/constants'

const device = 'Doorbell';

const installationInstructions = {
  intro: {
    currentStep: 'intro',
    currentStepName: 'installationIntro',
    headerIcon: 'arrowGrey',
    includeInstallationSteps: false,
    includePairingProcess: false,
    isLastPage: false,
    nextStep: 'beforePairing',
    nextStepName: 'instructions',
    prevStepName: 'https://return-to-app',
    primaryText: i18n.t('instructions.N102.congrats', { device }),
    haloDeviceResource: require('@/assets/device-models/N102/n102_halo.png'),
    resource: require('@/assets/device-models/N102/n102.png'),
    resourceType: 'image',
    secondaryTx:'instructions.N102.intro.text1' ,
    additionalTx:'instructions.N102.intro.text2',
    continueButtonTx: 'common.startInstallation',

    alternateNextStep: {
      nextStep: 'letsGetStarted',
      nextStepName: 'instructions',
      titleTx: 'common.skipToPairing',
    },
  },
  beforePairing: {
    currentStep: 'beforePairing',
    headerIcon: 'arrowGrey',
    isLastPage: false,
    nextStep: 'choice',
    nextStepName: 'instructions',
    prevStepName: 'installationIntro', // installationIntro doesn't have a prop of :step so omit `prevStep`
    prevStep: 'intro',
    resource: require('@/assets/device-models/N102/all_the_parts.png'),
    resourceType: 'image',
    primaryTx: 'instructions.N102.beforePairing.title',
    secondaryText: [ // note: have not been able to get to read from en.json
      i18n.t('instructions.N102.beforePairing.description', {device}),
      'Doorbell (1)',
      'Mounting Bracket (1)',
      'Mounting Wedge (1)',
      'Long Screws (2)',
      'Short Screws (2)',
      'Mounting Screws (2)',
      'Security Key (1)',
      'USB-C Cable (1)',
      'Wall Anchors (2)',
      'Wire Nuts (2)',
      'Extension Wires (2)',
      '\n',
      'To install your Doorbell you may also need these tools:',
      'Phillips-head Screwdriver',
      'Needle Nose Pliers',
      'Power Drill',
      'Hammer or Mallet',
      'Tape',
      'Marking Pen'
    ],

    alternateNextStep: {
      link: INSTALLATION_HELP_URL,
      titleTx: 'common.getInstallationHelp',
    },
  },
  choice: {
    currentStep: 'choice',
    headerIcon: 'arrowGrey',
    includeInstallationSteps: false,
    includePairingProcess: false,
    isLastPage: false,
    prevStep: 'beforePairing',
    prevStepName: 'instructions',
    titleTx: 'instructions.N102.choice.title',
    secondaryTx: i18n.t('instructions.N102.choice.description', { device }),

    steps: [
      {
        moreInfo: {
          includeIcon: true,
          titleTx: 'Battery',
          src: require('@/assets/icons/battery-icon.png'),
          primaryTx: 'instructions.N102.choice.moreinfo.title',
          nextStep: 'batteryStep1',
          nextStepName: 'instructions'
        },
      },
        {
          moreInfo: {
            includeIcon: true,
            src: require('@/assets/icons/power-icon.png'),
            primaryTx: 'instructions.N102.choice.moreinfo.title2',
            nextStep: 'wiredStep1',
            nextStepName: 'instructions'
          }
      },
      {
        description: i18n.t('instructions.N102.choice.step1.description', { device }),

      },
    ],
    alternateNextStep: {
      link: INSTALLATION_HELP_URL,
      titleTx: 'common.getInstallationHelp',
    },
  },

  'wiredStep1': {
    currentStep: 'wiredStep1',
    headerIcon: 'arrowGrey',
    includeBanner: false,
    isLastPage: false,
    nextStep: 'wiredStep2',
    nextStepName: 'instructions',
    prevStep: 'choice',
    prevStepName: 'instructions',
    resource: require('@/assets/device-models/N102/confirm_voltage_doorbell_transformer.png'),
    resourceType: 'image',
    continueButtonTx: 'common.next',
    primaryTx: 'instructions.N102.wiredStep1.title',
    secondaryText:[i18n.t('instructions.N102.wiredStep1.description1', { device }), i18n.t('instructions.N102.wiredStep1.description2')],

    alternateNextStep: {
      link: INSTALLATION_HELP_URL,
      titleTx: 'common.getInstallationHelp',
    },
  },
  'wiredStep2': {
    currentStep: 'wiredStep2',
    headerIcon: 'arrowGrey',
    includeBanner: false,
    isLastPage: false,
    nextStep: 'wiredStep3',
    nextStepName: 'instructions',
    prevStep: 'wiredStep1',
    prevStepName: 'instructions',
    resource: require('@/assets/device-models/N102/breaker_off.png'),
    resourceType: 'image',
    continueButtonTx: 'common.next',
    primaryTx: 'instructions.N102.wiredStep2.title',
    secondaryText:[i18n.t('instructions.N102.wiredStep2.description1', { device }), i18n.t('instructions.N102.wiredStep2.description2', { device })],

    alternateNextStep: {
      link: INSTALLATION_HELP_URL,
      titleTx: 'common.getInstallationHelp',
    },
  },
  'wiredStep3': {
    currentStep: 'wiredStep3',
    headerIcon: 'arrowGrey',
    includeBanner: false,
    isLastPage: false,
    nextStep: 'wiredStep4',
    nextStepName: 'instructions',
    prevStep: 'wiredStep2',
    prevStepName: 'instructions',
    resource: require('@/assets/device-models/N102/remove_old_doorbell.png'),
    resourceType: 'image',
    continueButtonTx: 'common.next',
    primaryTx: 'instructions.N102.wiredStep3.title',
    secondaryText:["Unscrew the doorbell from the wall and disconnect any attached wires."," You may want to use tape to keep the wires from falling into your wall. "],

    alternateNextStep: {
      link: INSTALLATION_HELP_URL,
      titleTx: 'common.getInstallationHelp',
    },
  },
  'wiredStep4': {
    currentStep: 'wiredStep4',
    headerIcon: 'arrowGrey',
    includeBanner: false,
    isLastPage: false,
    nextStep: 'wiredStep13',
    nextStepName: 'instructions',
    prevStep: 'wiredStep3',
    prevStepName: 'instructions',
    resource: require('@/assets/device-models/N102/mounting_wedge_wider_range_of_view.png'),
    resourceType: 'image',
    continueButtonTx: 'common.no',
    primaryTx: 'instructions.N102.mountingWedge.title',
    secondaryText:[i18n.t('instructions.N102.mountingWedge.description1', { device }), i18n.t('instructions.N102.mountingWedge.description2', { device }) ],
    alternateNextStep: {
      nextStep: 'wiredStep5',
      nextStepName: 'instructions',
      lastStep: 'wiredStep4', // go back to this step when home advisor is closed
      titleTx:'common.yes',
    },
  },
  'wiredStep5': {
    currentStep: 'wiredStep5',
    headerIcon: 'arrowGrey',
    includeBanner: false,
    isLastPage: false,
    nextStep: 'wiredStep6',
    nextStepName: 'instructions',
    prevStep: 'wiredStep4',
    prevStepName: 'instructions',
    resource: require('@/assets/device-models/N102/marking_mounting_wedge_wired.png'),
    resourceType: 'image',
    continueButtonTx: 'common.next',
    primaryTx: 'instructions.N102.positionMountingWedge.title',
    secondaryText: [i18n.t('instructions.N102.positionMountingWedge.description1', { device }),i18n.t('instructions.N102.positionMountingWedge.description2', { device })],

    alternateNextStep: {
      link: INSTALLATION_HELP_URL,
      titleTx: 'common.getInstallationHelp',
    },
  },

  'wiredStep6': {
    currentStep: 'wiredStep6',
    headerIcon: 'arrowGrey',
    includeBanner: false,
    isLastPage: false,
    nextStep: 'wiredStep7',
    nextStepName: 'instructions',
    prevStep: 'wiredStep5',
    prevStepName: 'instructions',
    titleTx: 'instructions.N102.screwOrDrill.title',
    continueButtonTx: 'common.next',
    resource: require('@/assets/device-models/N102/installing_mounting_wedge_wired.png'),
    resourceType: 'image',

    steps: [
      {
        titleTx: 'instructions.N102.screwOrDrill.subtitle1',
        descriptionTx: 'instructions.N102.screwOrDrill.description1',
      },
      {
        descriptionTx:'instructions.N102.screwOrDrill.description1a',
      },
      {
        titleTx: 'instructions.N102.screwOrDrill.subtitle2',
        descriptionTx: 'instructions.N102.screwOrDrill.description2',
      },
    ],
    alternateNextStep: {
      link: INSTALLATION_HELP_URL,
      titleTx: 'common.getInstallationHelp',
    },
  },
  'wiredStep7': {
    currentStep: 'wiredStep7',
    headerIcon: 'arrowGrey',
    includeBanner: false,
    isLastPage: false,
    nextStep: 'wiredStep8',
    nextStepName: 'instructions',
    prevStep: 'wiredStep6',
    prevStepName: 'instructions',
    resource: require('@/assets/device-models/N102/connect_wires_direct_install.png'),
    resourceType: 'image',
    continueButtonTx: 'common.next',
    primaryTx: 'instructions.N102.connectwires.title',
    secondaryText:[i18n.t('instructions.N102.connectwires.text1'), i18n.t('instructions.N102.connectwires.text2'), i18n.t('instructions.N102.connectwires.text3')],

    alternateNextStep: {
      link: INSTALLATION_HELP_URL,
      titleTx: 'common.getInstallationHelp',
    },
  },
  'wiredStep8': {
    currentStep: 'wiredStep8',
    headerIcon: 'arrowGrey',
    includeBanner: false,
    isLastPage: false,
    nextStep: 'wiredStep9',
    nextStepName: 'instructions',
    prevStep: 'wiredStep7',
    prevStepName: 'instructions',
    resource: require('@/assets/device-models/N102/installing_Into_wall_w_wedge_wired.png'),
    resourceType: 'image',
    continueButtonTx: 'common.next',

    primaryTx: 'instructions.N102.attachMountingBracket.title',
    secondaryText: [i18n.t('instructions.N102.attachMountingBracket.description1')],

    alternateNextStep: {
      link: INSTALLATION_HELP_URL,
      titleTx: 'common.getInstallationHelp',
    },
  },
  'wiredStep9': {
    currentStep: 'wiredStep9',
    headerIcon: 'arrowGrey',
    includeBanner: false,
    isLastPage: false,
    nextStep: 'wiredStep10',
    nextStepName: 'instructions',
    prevStep: 'wiredStep8',
    prevStepName: 'instructions',
    resource: require('@/assets/device-models/N102/marking_bracket_wired.png'),
    resourceType: 'image',
    continueButtonTx: 'common.next',

    primaryTx: 'instructions.N102.mountingBracket.title',
    secondaryText:[i18n.t('instructions.N102.mountingBracket.description1', { device }), i18n.t('instructions.N102.mountingBracket.description2', { device }) ],

    alternateNextStep: {
      link: INSTALLATION_HELP_URL,
      titleTx: 'common.getInstallationHelp',
    },
  },
  'wiredStep10': {
    currentStep: 'wiredStep10',
    headerIcon: 'arrowGrey',
    includeBanner: false,
    isLastPage: false,
    nextStep: 'wiredStep11',
    nextStepName: 'instructions',
    prevStep: 'wiredStep9',
    prevStepName: 'instructions',
    resource: require('@/assets/device-models/N102/attaching_doorbell.png'),
    resourceType: 'image',
    continueButtonTx: 'common.next',
    primaryTx: 'instructions.N102.wiredStep10.title',
    secondaryText:[i18n.t('instructions.N102.wiredStep10.description1', { device }), i18n.t('instructions.N102.wiredStep10.description2', { device }) ],
    alternateNextStep: {
      link: INSTALLATION_HELP_URL,
      titleTx: 'common.getInstallationHelp',
    },
  },
  'wiredStep11': {
    currentStep: 'wiredStep11',
    headerIcon: 'arrowGrey',
    includeBanner: false,
    isLastPage: false,
    nextStep: 'wiredStep12',
    nextStepName: 'instructions',
    prevStep: 'wiredStep10',
    prevStepName: 'instructions',
    resource: require('@/assets/device-models/N102/breaker_on_option_1.png'),
    resourceType: 'image',
    continueButtonTx: 'common.next',
    primaryText: i18n.t('instructions.N102.wiredStep11.title', { device }),
    secondaryText: ["Go back to your home’s circuit breaker and switch on the power to your doorbell."],

    alternateNextStep: {
      link: INSTALLATION_HELP_URL,
      titleTx: 'common.getInstallationHelp',
    },
  },
  'wiredStep12': {
    currentStep: 'wiredStep12',
    headerIcon: 'arrowGrey',
    includeBanner: false,
    isLastPage: false,
    nextStep: 'letsGetStarted',
    nextStepName: 'instructions',
    prevStep: 'wiredStep11',
    prevStepName: 'instructions',
    resource: require('@/assets/device-models/N102/confetti_option_1.png'),
    resourceType: 'image',
    continueButtonTx: 'common.continueToPairing',
    primaryTx: 'instructions.N102.wiredStep12.title',
    secondaryText:[i18n.t('instructions.N102.wiredStep10.description1', { device }), i18n.t('instructions.N102.wiredStep10.description2', { device }) ],
  },
  'wiredStep13': {
    currentStep: 'wiredStep13',
    headerIcon: 'arrowGrey',
    includeBanner: false,
    isLastPage: false,
    nextStep: 'wiredStep14',
    nextStepName: 'instructions',
    prevStep: 'wiredStep4',
    prevStepName: 'instructions',
    resource: require('@/assets/device-models/N102/marking_bracket_wired.png'),
    resourceType: 'image',
    continueButtonTx: 'common.next',
    primaryTx: 'instructions.N102.mountingBracket.title',
    secondaryText:[i18n.t('instructions.N102.mountingBracket.description1', { device }), i18n.t('instructions.N102.mountingBracket.description2', { device }) ],
    alternateNextStep: {
      link: INSTALLATION_HELP_URL,
      titleTx: 'common.getInstallationHelp',
    },
  },
  'wiredStep14': {
    currentStep: 'wiredStep14',
    headerIcon: 'arrowGrey',
    includeBanner: false,
    isLastPage: false,
    nextStep: 'wiredStep15',
    nextStepName: 'instructions',
    prevStep: 'wiredStep13',
    prevStepName: 'instructions',
    resource: require('@/assets/device-models/N102/connect_wires_w_wedge.png'),
    resourceType: 'image',
    continueButtonTx: 'common.next',
    primaryTx: 'instructions.N102.connectwires.title',
    secondaryText:[i18n.t('instructions.N102.connectwires.text1'), i18n.t('instructions.N102.connectwires.text2'), i18n.t('instructions.N102.connectwires.text3')],
    alternateNextStep: {
      link: INSTALLATION_HELP_URL,
      titleTx: 'common.getInstallationHelp',
    },
  },
  'wiredStep15': {
    currentStep: 'wiredStep15',
    headerIcon: 'arrowGrey',
    includeBanner: false,
    isLastPage: false,
    nextStep: 'wiredStep10',
    nextStepName: 'instructions',
    prevStep: 'wiredStep14',
    prevStepName: 'instructions',
    titleTx: 'instructions.N102.screwOrDrill.title',
    resource: require('@/assets/device-models/N102/installing_mounting_wedge_wired.png'),
    resourceType: 'image',
    continueButtonTx: 'common.next',
    steps: [
      {
        titleTx: 'instructions.N102.screwOrDrill.subtitle1',
        descriptionTx: 'instructions.N102.screwOrDrill.description1',
      },
      {
        descriptionTx:'instructions.N102.screwOrDrill.description1a',
      },
      {
        titleTx: 'instructions.N102.screwOrDrill.subtitle2',
        descriptionTx: 'instructions.N102.screwOrDrill.description2'
      }
    ],
    alternateNextStep: {
      link: INSTALLATION_HELP_URL,
      titleTx: 'common.getInstallationHelp',
    },
  },
  'batteryStep1': {
    currentStep: 'batteryStep1',
    headerIcon: 'arrowGrey',
    includeBanner: false,
    isLastPage: false,
    nextStep: 'batteryStep2',
    nextStepName: 'instructions',
    prevStep: 'choice',
    prevStepName: 'instructions',
    resource: require('@/assets/device-models/N102/usb_c_plugged_into_the_wall-option_2.png'),
    resourceType: 'image',
    continueButtonTx: 'common.beginInstall',
    primaryText: i18n.t('instructions.N102.batteryStep1.title', { device }),
    secondaryText: [i18n.t('instructions.N102.batteryStep1.description1', { device })],
    alternateNextStep: {
      link: INSTALLATION_HELP_URL,
      titleTx: 'common.getInstallationHelp',
    },
  },
  'batteryStep2': {
    currentStep: 'batteryStep2',
    headerIcon: 'arrowGrey',
    includeBanner: false,
    isLastPage: false,
    nextStep: 'batteryStep4',
    nextStepName: 'instructions',
    prevStep: 'batteryStep1',
    prevStepName: 'instructions',

    resource: require('@/assets/device-models/N102/remove_old_doorbell.png'),
    resourceType: 'image',
    continueButtonTx: 'common.no',
    primaryTx: 'instructions.N102.batteryStep2.title',
    secondaryText: ["If you currently have a wired doorbell that you need to remove, there are a couple of additional steps we'll need to walk you through."],

    alternateNextStep: {
      nextStep: 'batteryStep3',
      nextStepName: 'instructions',
      lastStep: 'batteryStep2',
      titleTx: 'common.yes',
    },
  },
  'batteryStep3': {
    currentStep: 'batteryStep3',
    headerIcon: 'arrowGrey',
    includeBanner: false,
    isLastPage: false,
    nextStep: 'batteryStep4',
    nextStepName: 'instructions',
    prevStep: 'batteryStep2',
    prevStepName: 'instructions',
    resource: require('@/assets/device-models/N102/remove_old_doorbell.png'),
    resourceType: 'image',
    continueButtonTx: 'common.next',
    primaryTx: 'instructions.N102.batteryStep3.title',
    secondaryText: ["Unscrew the doorbell from the wall and disconnect any attached wires. You may want to use tape to keep the wires from falling into your wall."],
    alternateNextStep: {
      link: INSTALLATION_HELP_URL,
      titleTx: 'common.getInstallationHelp',
    },
  },
  'batteryStep4': {
    currentStep: 'batteryStep4',
    headerIcon: 'arrowGrey',
    includeBanner: false,
    isLastPage: false,
    nextStep: 'batteryStep8',
    nextStepName: 'instructions',
    prevStep: 'batteryStep3',
    prevStepName: 'instructions',

    resource: require('@/assets/device-models/N102/mounting_wedge_wider_range_of_view.png'),
    resourceType: 'image',
    continueButtonTx: 'common.no',
    primaryTx: 'instructions.N102.batteryStep4.title',
    secondaryText: [i18n.t('instructions.N102.mountingWedge.description1', { device }),i18n.t('instructions.N102.mountingWedge.description2', { device })],
    alternateNextStep: {
      nextStep: 'batteryStep5',
      nextStepName: 'instructions',
      lastStep: 'batteryStep4',
      titleTx: 'common.yes',
    },
  },
  'batteryStep5': {
    currentStep: 'batteryStep5',
    headerIcon: 'arrowGrey',
    includeBanner: false,
    isLastPage: false,
    nextStep: 'batteryStep6',
    nextStepName: 'instructions',
    prevStep: 'batteryStep4',
    prevStepName: 'instructions',
    titleTx: '',
    resource: require('@/assets/device-models/N102/marking_mounting_wedge_wired.png'),
    resourceType: 'image',
    continueButtonTx: 'common.next',
    primaryTx: 'instructions.N102.positionMountingWedge.title',
    secondaryText: [i18n.t('instructions.N102.positionMountingWedge.description1', { device }),i18n.t('instructions.N102.positionMountingWedge.description2', { device })],
    alternateNextStep: {
      link: INSTALLATION_HELP_URL,
      titleTx: 'common.getInstallationHelp',
    },
  },
  'batteryStep6': {
    currentStep: 'batteryStep6',
    headerIcon: 'arrowGrey',
    includeBanner: false,
    isLastPage: false,
    nextStep: 'batteryStep7',
    nextStepName: 'instructions',
    prevStep: 'batteryStep5',
    prevStepName: 'instructions',
    titleTx: 'instructions.N102.screwOrDrill.title',
    resource: require('@/assets/device-models/N102/installing_mounting_wedge_non-wired.png'),
    resourceType: 'image',
    continueButtonTx: 'common.next',
    steps: [
      {
        titleTx: 'instructions.N102.screwOrDrill.subtitle1',
        descriptionTx: 'instructions.N102.screwOrDrill.description1',
      },
      {
        descriptionTx:'instructions.N102.screwOrDrill.description1a',
      },
      {
        titleTx: 'instructions.N102.screwOrDrill.subtitle2',
        descriptionTx: 'instructions.N102.screwOrDrill.description2',
      }
    ],
    alternateNextStep: {
      link: INSTALLATION_HELP_URL,
      titleTx: 'common.getInstallationHelp',
    },
  },
  'batteryStepMount': {
    currentStep: 'batteryStepMount',
    headerIcon: 'arrowGrey',
    includeBanner: false,
    isLastPage: false,
    nextStep: 'batteryStep9',
    nextStepName: 'instructions',
    prevStep: 'batteryStep4',
    prevStepName: 'instructions',
    titleTx: 'instructions.N102.screwOrDrill.title',
    resource: require('@/assets/device-models/N102/installing_mounting_wedge_non-wired.png'),
    resourceType: 'image',
    continueButtonTx: 'common.next',
    steps: [
      {
        titleTx: 'instructions.N102.screwOrDrill.subtitle1',
        descriptionTx: 'instructions.N102.screwOrDrill.description1',
      },
      {
        descriptionTx:'instructions.N102.screwOrDrill.description1a',
      },
      {
        titleTx: 'instructions.N102.screwOrDrill.subtitle2',
        descriptionTx: 'instructions.N102.screwOrDrill.description2',
      }
    ],
    alternateNextStep: {
      link: INSTALLATION_HELP_URL,
      titleTx: 'common.getInstallationHelp',
    },
  },
  'batteryStep7': {
    currentStep: 'batteryStep7',
    headerIcon: 'arrowGrey',
    includeBanner: false,
    isLastPage: false,
    nextStep: 'batteryStepAttach',
    nextStepName: 'instructions',
    prevStep: 'batteryStep3',
    prevStepName: 'instructions',

    resource: require('@/assets/device-models/N102/installing_into_wall_w_wedge_non_wired.png'),
    resourceType: 'image',
    continueButtonTx: 'common.next',
    primaryTx: 'instructions.N102.attachMountingBracket.title',
    secondaryText: [i18n.t('instructions.N102.attachMountingBracket.description1')],

    alternateNextStep: {
      link: INSTALLATION_HELP_URL,
      titleTx: 'common.getInstallationHelp',
    },
  },
  'batteryStep8': {
    currentStep: 'batteryStep8',
    headerIcon: 'arrowGrey',
    includeBanner: false,
    isLastPage: false,
    nextStep: 'batteryStepMount',
    nextStepName: 'instructions',
    prevStep: 'batteryStep4',
    prevStepName: 'instructions',

    resource: require('@/assets/device-models/N102/marking_bracket_non_wired.png'),
    resourceType: 'image',
    continueButtonTx: 'common.next',
    primaryTx: 'instructions.N102.mountingBracket.title',
    secondaryText: [i18n.t('instructions.N102.mountingBracket.description1', { device }),i18n.t('instructions.N102.mountingBracket.description2', { device })],

    alternateNextStep: {
      link: INSTALLATION_HELP_URL,
      titleTx: 'common.getInstallationHelp',
    },
  },
  'batteryStep9': {
    currentStep: 'batteryStep9',
    headerIcon: 'arrowGrey',
    includeBanner: false,
    isLastPage: false,
    nextStep: 'batteryStep10',
    nextStepName: 'instructions',
    prevStep: 'batteryStep8',
    prevStepName: 'instructions',
    resource: require('@/assets/device-models/N102/attaching_doorbell.png'),
    resourceType: 'image',
    continueButtonTx: 'common.next',
    primaryText: i18n.t('instructions.N102.batteryStep9.title', { device }),
    secondaryText: [i18n.t('instructions.N102.wiredStep10.description1', { device }),i18n.t('instructions.N102.wiredStep10.description2', { device })],

    alternateNextStep: {
      link: INSTALLATION_HELP_URL,
      titleTx: 'common.getInstallationHelp',
    },
  },
  'batteryStepAttach': {
    currentStep: 'batteryStepAttach',
    headerIcon: 'arrowGrey',
    includeBanner: false,
    isLastPage: false,
    nextStep: 'batteryStep10',
    nextStepName: 'instructions',
    prevStep: 'batteryStep7',
    prevStepName: 'instructions',
    resource: require('@/assets/device-models/N102/attaching_doorbell.png'),
    resourceType: 'image',
    continueButtonTx: 'common.next',
    primaryText: i18n.t('instructions.N102.batteryStep9.title', { device }),
    secondaryText: [i18n.t('instructions.N102.wiredStep10.description1', { device }),i18n.t('instructions.N102.wiredStep10.description2', { device })],

    alternateNextStep: {
      link: INSTALLATION_HELP_URL,
      titleTx: 'common.getInstallationHelp',
    },
  },
  'batteryStep10': {
    currentStep: 'batteryStep10',
    headerIcon: 'arrowGrey',
    includeBanner: false,
    isLastPage: false,
    nextStep: 'letsGetStarted',
    nextStepName: 'instructions',
    prevStep: 'batteryStep9',
    prevStepName: 'instructions',

    resource: require('@/assets/device-models/N102/confetti_option_1.png'),
    resourceType: 'image',
    continueButtonTx: 'common.continueToPairing',
    primaryTx: 'instructions.N102.batteryStep10.title',
    secondaryText: [i18n.t('instructions.N102.wiredStep12.description1', { device }),i18n.t('instructions.N102.wiredStep12.description2', { device })],
  },
  letsGetStarted: {
    headerIcon: 'arrowGrey',
    currentStep: 'letsGetStarted',
    isLastPage: true,
    lastPageExitUrl: 'https://www.exit-installation-instructions-flow',
    prevStep: 'intro',
    prevStepName: 'installationIntro',
    resource: require('@/assets/device-models/N102/welcome_doorbell.png'),
    resourceType: 'image',
    primaryTx: i18n.t('instructions.N102.letsGetStarted.title', {device}),
    secondaryTx: 'instructions.N102.letsGetStarted.subtitle',
    steps: [
      {
        titleTx: 'instructions.N102.letsGetStarted.step1.title',
        descriptionTx: 'instructions.N102.letsGetStarted.step1.description',
        stepNumber: 1
      },
      {
        titleTx: 'instructions.N102.letsGetStarted.step2.title',
        descriptionTx: 'instructions.N102.letsGetStarted.step2.description',
        stepNumber: 2
      },
    ],
    continueButtonTx: 'common.ready',
    alternateNextStep: {
      nextStep: 'pairingModeReset',
      nextStepName: 'instructions',
      lastStep: 'letsGetStarted',
      titleTx: 'common.readInstructions',
    },
  },
  pairingModeReset: {
    currentStep: 'pairingModeReset',
    headerIcon: 'arrowGrey',
    isLastPage: false,
    nextStep: 'letsGetStarted',
    nextStepName: 'instructions',
    prevStep: 'letsGetStarted',
    prevStepName: 'instructions',
    primaryTx: i18n.t('instructions.N102.pairingModeReset.title', { device }),
    secondaryTx: i18n.t('instructions.N102.pairingModeReset.subtitle', { device }),
    resource: require('@/assets/device-models/N102/welcome_doorbell.png'),
    resourceType: 'image',
    steps: [
      {
        title: i18n.t('instructions.N102.pairingModeReset.step1.title', { device }),
        descriptionTx: 'instructions.N102.pairingModeReset.step1.description',
        stepNumber: 1
      },
      {
        titleTx: 'instructions.N102.pairingModeReset.step2.title',
        description:i18n.t('instructions.N102.pairingModeReset.step2.description', { device }),
        stepNumber: 2
      }
    ],
  }
};

export default installationInstructions;
